module.exports = __webpack_public_path__ + "img/AI TTS.03d8bc26.svg";